import Markdown from "solar/components/Markdown";
import Title from "components/shared/stays/Title";
import Text from "components/shared/stays/Text";
import Anchor from "solar/components/Anchor";
import Youtube from "components/shared/adventures/Youtube";
import SectionRhythm from "components/shared/stays/SectionRhythm";
import styles from "components/stay/StabDescription.module.scss";

export default function StabDescription() {
  const introContent = `If you've seen any of the Electric Acid Surfboard Test (EAST) films, you know that watching a pro unpack board bag after board bag of eccentric sleds from the world's best shapers evokes two primal feelings: Excitement and envy. We want you to feel that first one, but envy should be reserved for space travel and Colin Jost. You should be able to take your own Acid Test. With this in mind, we created the Electric Acid Trip, a bespoke EAST that you can take with your best friends.`;
  const bodyContent = `
- **Who:** You and up to seven of your friends

- **What:** 10 custom boards, your own Electric Acid Surfboard Test and a 10 to 20-minute film documenting the experience, captured and cut by Stab’s filmmaking wizards. Congrats, this is your small screen debut.

- **Where:** Salina Cruz, Mexico

- **When:** Spring 2022, when conditions are prime. But we're flexible, if you've got other dates in mind.

- **Why:** Because this is one of those opportunities that will summit your bucket list and stare at you, teasing. We see how fun it is for the Dane’s, Mason’s and Steph’s of the world. For you? It’s a once-in-a-lifetime experience.

A couple disclaimers… With film production and the creation of these custom boards — **which you get to keep, btw** — this trip is expensive, coming in at just over six figures (split between you and your crew). We’re not trying to be elitists. We know most people can’t afford this. But, if we find that there’s an appetite for this kind of trip, we’ll create more and focus on bringing the price down. Which brings us to our next point.

This is an experiment. We don’t know if this turns you on or if you just want to watch your heroes rip twin fins, but we thought we’d roll the dice and let you decide.

There’s one trip available. First in, best dressed. Book exclusively here.
  `;
  return (
    <div className={styles.component}>
      <Anchor id="description" offset />
      <Title>The gist</Title>
      <SectionRhythm>
        <Text>
          <Markdown>{introContent}</Markdown>
          <div className={styles.video}>
            <Youtube aspectRatio="16:9" videoId="XxBo1Hn2d5E" />
          </div>
          <Markdown>{bodyContent}</Markdown>
        </Text>
      </SectionRhythm>
    </div>
  );
}
